import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { handleKeyPressSpace } from "../../common/CommonFunctions";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { BreadCrum } from "../../common";
import { getProductParentRoute } from "../product/productNavigation";
import { useDispatch, useSelector } from "react-redux";
import { useCommonMessage } from "../../common/CommonMessage";
import Loader from "../Loder/loader";
import uploadimg from "../../assets/uploadicon.svg";
import eye from "../../assets/viewPdfEyeIcon.svg";
import deleteicon from "../../assets/deleteicon.svg";
import { Checkbox, message, Upload } from "antd";
import { ThemeContext } from "../../common/themeContext";
import axios from "axios";
import { API_URL } from "../../services/http";
import { fileUploadAction } from "../../redux/action/fileUpload";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import {
  addProductFeatureAction,
  addProductFeaturesHandler,
} from "../../redux/action/addProductFeaturesSlice";
import {
  dpcExtraDiscountValidation,
  dpcExtraDiscountValidationSpanish,
} from "../../common/Validations";
import { getItem } from "../../common/localStorage";
import { isProfilePermissionCheckPending, isSuperAdmin } from "../../common/permissions";
import {
  getProductGroupPermissions,
  mergePermissionGroupsWithDefaults,
} from "../../hooks/useAdminPermissions";

const AddDpcDiscount = () => {
  const [fileUploaded, setFileUploaded] = useState("");
  const [spanishFileUpload, setSpanishFileUpload] = useState("");
  const [loading, setLoading] = useState(false);
  const messageApi = useCommonMessage();
  const { Dragger } = Upload;
  const fileUploadDataSelector = useSelector((state) => state?.fileUploadData);
  const getAdminLoginId = getItem("adminId");
  const getProductId = getItem("productId");
  const refFeatureId = getItem("refFeatureId");

  const { brandId } = useContext(ThemeContext);
  const { state } = useLocation();
  const fileUploadSelector = useSelector((state) => state?.fileUploadData);
  const getProductFeatureContentSelector = useSelector(
    (state) => state?.getProductFeatureContentMain
  );

  let fileUploadData = fileUploadDataSelector?.data?.data;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileState = useSelector((state) => state?.getAdminProfile);
  const profile = profileState?.data?.data ?? profileState?.data ?? null;
  const permissionGroups = useMemo(
    () => mergePermissionGroupsWithDefaults(profile?.permissions),
    [profile?.permissions],
  );
  const productPermissions = useMemo(
    () => getProductGroupPermissions(permissionGroups),
    [permissionGroups],
  );
  const canEditProducts =
    isSuperAdmin(profileState) || productPermissions.hasEdit;
  const permissionsPending = isProfilePermissionCheckPending(profileState);

  const addProductFeaturesSelector = useSelector(
    (state) => state?.addProductFeatures
  );

  const props = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    showUploadList: false,
    async beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error("You can only upload PDF files!");
        setFileUploaded("");
        return false;
      }
      const isSizeAccepted = file.size / 1024 / 1024 <= 10;
      if (!isSizeAccepted) {
        message.error("File size exceeds 10MB limit!");
        setFileUploaded("");
        return false;
      }
      if (isPDF && isSizeAccepted) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", Number(getAdminLoginId));
        formData.append("brandId", brandId);
        formData.append(
          "path",
          `${
            "product/" +
            getProductFeatureContentSelector?.data?.data?.productCode
          }/${state?.state?.item?.featureName}/${state?.selectedDiscountType}/${
            state?.manageSwitch === false ? "English" : "Spanish"
          }`
        );
        setLoading(true);
        axios
          .post(API_URL + "/file/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            dispatch(fileUploadAction.fileUploadInfoSuccess(response.data));
            if (state?.manageSwitch === false) {
              setFileUploaded(file?.name);
            } else {
              setSpanishFileUpload(file?.name);
            }
          })
          .catch((error) => {
            dispatch(fileUploadAction.fileUploadInfoFailure(error));
          })
          .finally(() => {
            setLoading(false);
          });
        if (state?.manageSwitch === false) {
          setFileUploaded(file?.name);
        } else {
          setSpanishFileUpload(file?.name);
        }
      }
      return false;
    },
  };

  useEffect(() => {
    if (permissionsPending || canEditProducts) {
      return;
    }

    navigate("/dpc-extra", { replace: true });
  }, [canEditProducts, navigate, permissionsPending]);

  useEffect(() => {
    if (permissionsPending || !canEditProducts) {
      return;
    }

    if (Number(refFeatureId)) {
      dispatch(
        getProductFeatureContentHandler({
          productId: Number(getProductId),
          refFeatureId: Number(refFeatureId),
        }),
      );
    }
  }, [canEditProducts, dispatch, getProductId, permissionsPending, refFeatureId]);

  const handleFormSubmit = (values) => {
    const isEnglish = state?.manageSwitch === false;
    const productId = Number(getProductId);
    const featureId = Number(refFeatureId);

    // Check if the selected discount type matches any component's name
    const isMatch =
      getProductFeatureContentSelector?.data?.data?.content?.componants.some(
        (ele) =>
          ele.name?.trim().toLowerCase() ===
          state?.selectedDiscountType?.trim().toLowerCase()
      );

    // Assuming you have access to the existing data, such as:
    const existingComponents =
      getProductFeatureContentSelector?.data?.data?.content?.componants || [];

    // Filter components based on the match condition
    const components = existingComponents.map((item) => {
      // Only process the component if it matches the selectedDiscountType
      const matchingCondition =
        item.name?.trim().toLowerCase() ===
        state?.selectedDiscountType?.trim().toLowerCase();

      // Only modify the matched component, otherwise return it unchanged
      if (matchingCondition) {
        return {
          name: item?.name,
          english: isEnglish
            ? {
                url: values?.discountUrlEnglish || item?.english?.url,
                phone:
                  values?.phoneNumberEnglish.toString() ||
                  item?.english?.phone.toString(),
                fileUrl:
                  fileUploadSelector?.data?.data?.signedUrl ||
                  item?.english?.fileUrl,
                filePreSigned:
                  fileUploadSelector?.data?.data?.preSignedUrl ||
                  item?.english?.filePreSigned,
                fileName: fileUploaded || item?.english?.fileName,
                isValuePresent: state?.manageSwitch === false ? true : false,
                isVirtualCare: values?.isVirtualCareEnglish || item?.english?.isVirtualCare,
                virtualCare: item?.english?.virtualCare,
              }
            : {
                url: item?.english?.url || "",
                phone: item?.english?.phone.toString() || "",
                fileUrl: item?.english?.fileUrl || "",
                filePreSigned: item?.english?.filePreSigned || "",
                fileName: item?.english?.fileName || "",
                isValuePresent: item?.english?.isValuePresent,
                isVirtualCare: item?.english?.isVirtualCare,
                virtualCare: item?.english?.virtualCare,
              },
          spanish: !isEnglish
            ? {
                url: values?.discountUrlSpanish || item?.spanish?.url || "",
                phone:
                  values?.phoneNumberSpanish.toString() ||
                  item?.spanish?.phone.toString() ||
                  "",
                fileUrl: spanishFileUpload
                  ? fileUploadSelector?.data?.data?.signedUrl
                  : item?.spanish?.fileUrl,
                filePreSigned: spanishFileUpload
                  ? fileUploadSelector?.data?.data?.preSignedUrl
                  : item?.spanish?.filePreSigned,
                fileName: spanishFileUpload || item?.spanish?.fileName || "",
                isValuePresent: state?.manageSwitch === true ? true : false,
                isVirtualCare: values?.isVirtualCareSpanish || item?.spanish?.isVirtualCare,
                virtualCare: item?.spanish?.virtualCare,
              }
            : {
                url: item?.spanish?.url || "",
                phone: item?.spanish?.phone.toString() || "",
                fileUrl: item?.spanish?.fileUrl || "",
                filePreSigned: item?.spanish?.filePreSigned || "",
                fileName: item?.spanish?.fileName || "",
                isValuePresent: item?.spanish?.isValuePresent,
                isVirtualCare: item?.spanish?.isVirtualCare,
                virtualCare: item?.spanish?.virtualCare,
              },
          status: item?.status,
          // Only update language for matching components
          language: state?.manageSwitch === false ? "en" : "es",
          isSelected: true,
          spanishName:item?.spanishName
        };
      }
      // Return unchanged component for non-matching ones
      return {
        ...item,
        english: {
          url: item?.english?.url || "",
          phone: item?.english?.phone || "",
          fileUrl: item?.english?.fileUrl || "",
          filePreSigned: item?.english?.filePreSigned || "",
          fileName: item?.english?.fileName || "",
          isValuePresent: item?.english?.isValuePresent || false,
          isVirtualCare: item?.english?.isVirtualCare,
          virtualCare: item?.english?.virtualCare,
        },
        spanish: {
          url: item?.spanish?.url || "",
          phone: item?.spanish?.phone || "",
          fileUrl: item?.spanish?.fileUrl || "",
          filePreSigned: item?.spanish?.filePreSigned || "",
          fileName: item?.spanish?.fileName || "",
          isValuePresent: item?.spanish?.isValuePresent || false,
          isVirtualCare: item?.spanish?.isVirtualCare,
          virtualCare: item?.spanish?.virtualCare,
        },
        status: item?.status,
        isSelected: item?.isSelected !== undefined ? item.isSelected : true, // New components are selected by default
        language: state?.manageSwitch === false ? "en" : "es",
        spanishName:item?.spanishName
      };
    });

    const payload = {
      productId,
      featureId,
      content: {
        type: getProductFeatureContentSelector?.data?.data?.content?.type,
        componants: components,
      },
    };
    dispatch(addProductFeaturesHandler(payload, { skipForbiddenRedirect: true }));
  };

  // Delete File
  const deleteFile = () => {
    setFileUploaded("");
    setSpanishFileUpload("");
    dispatch(fileUploadAction.fileUploadInfoReset());
  };

  useEffect(() => {
    if (addProductFeaturesSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: addProductFeaturesSelector?.data?.message,
      });
      navigate("/dpc-extra");
      dispatch(fileUploadAction.fileUploadInfoReset());
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
    } else if (addProductFeaturesSelector?.statusCode === 405) {
      messageApi.open({
        type: "warning",
        content:
          addProductFeaturesSelector?.message ||
          "You don't have permission to access this page.",
      });
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
      navigate("/dpc-extra", { replace: true });
    } else if (addProductFeaturesSelector?.message) {
      messageApi.open({
        type: "error",
        content: addProductFeaturesSelector?.message,
      });
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
    }
  }, [addProductFeaturesSelector, dispatch, messageApi, navigate]);

  if (permissionsPending || !canEditProducts) {
    return <Loader loaderTransForm="loaderTransForm" />;
  }

  return (
    <>
      {(addProductFeaturesSelector?.isLoading === true ||
        fileUploadDataSelector?.isLoading === true ||
        getProductFeatureContentSelector?.isLoading === true ||
        loading) && <Loader loaderTransForm="loaderTransForm" />}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Products</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              {
                text: BreadCrum.PRODUCTS,
                onClick: () => navigate("/product"),
              },
              {
                text: BreadCrum.MANAGE_PRODUCTS,
                onClick: () =>
                  navigate(getProductParentRoute(state || {}), {
                    state: state?.productData,
                  }),
              },
              {
                text: BreadCrum.DPC_EXTRA_LIST,
                onClick: () => navigate("/dpc-extra"),
              },
              {
                text: BreadCrum.DPC_EXTRA,
                active: true,
              },
            ]}
          />
          <div className="redirectionlink d-n one">
            <div className="sectionpadding d-block mb-30 hoversection btnPosition">
              <div className="d-flex justify-content-between align-items-center">
                <p className="mb-0 heedprodct">
                  {state?.selectedDiscountType || "DPCextra"}
                </p>
              </div>
              <hr />
              <Formik
                enableReinitialize
                initialValues={{
                  discountUrlEnglish: "",
                  discountUrlSpanish: "",
                  phoneNumberEnglish: "",
                  phoneNumberSpanish: "",
                  isVirtualCareEnglish: false,
                  isVirtualCareSpanish: false,
                }}
                validationSchema={
                  state?.selectedDiscountType === "Telemedicine"
                    ? null  
                    : state?.manageSwitch === false
                    ? dpcExtraDiscountValidation
                    : dpcExtraDiscountValidationSpanish
                }
                onSubmit={(values, formikBag) => {
                  handleFormSubmit(values, formikBag);
                }}
              >
                {({ errors }) => (
                  <Form className="login-form">
                    {state?.selectedDiscountType !== "Telemedicine" && (
                      <div className="mb-30 d-flex fullwidth gap-20">
                        <div>
                          <Field
                            type="text"
                            placeholder="URL"
                            name={

                              state?.manageSwitch === false 
                                ? "discountUrlEnglish"
                                : "discountUrlSpanish"
                            }
                            className="form-control"
                            onKeyPress={handleKeyPressSpace}
                            autoComplete="Off"
                          />
                          <ErrorMessage
                            name={
                              state?.manageSwitch === false 
                                ? "discountUrlEnglish"
                                : "discountUrlSpanish"
                            }
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                        <div>
                          <Field
                            type="number"
                            name={
                              state?.manageSwitch === false
                                ? "phoneNumberEnglish"
                                : "phoneNumberSpanish"
                            }
                            placeholder="Phone Number"
                            className="form-control"
                            onKeyPress={handleKeyPressSpace}
                            onKeyDown={(event) => {
                              if (
                                ["ArrowUp", "ArrowDown"].includes(event.key)
                              ) {
                                event.preventDefault();
                              }
                            }}
                            maxLength="15"
                            autoComplete="Off"
                          />
                          <ErrorMessage
                            name={
                              state?.manageSwitch === false 
                                ? "phoneNumberEnglish"
                                : "phoneNumberSpanish"
                            }
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    )}
                    {state?.selectedDiscountType === "Telemedicine" && (
                      <>

                        {state?.manageSwitch === false ? (
                          <Field type="checkbox" name="isVirtualCareEnglish">
                            {({ field }) => (
                              <>
                              <Checkbox {...field} checked={field.value}>
                                Virtual Care
                              </Checkbox>
                              </>
                            )}
                          </Field>
                        ) : (
                          <Field type="checkbox" name="isVirtualCareSpanish">
                            {({ field }) => (
                              <Checkbox {...field} checked={field.value}>
                                Virtual Care
                              </Checkbox>
                            )}
                          </Field>
                        )}
                      </>
                    )}

                    {!(fileUploaded || spanishFileUpload) ? (
                      <Field name="file_upload">
                        {({ field }) => (
                          <Dragger {...props} className="mb-30 d-block">
                            <p className="ant-upload-drag-icon">
                              <img src={uploadimg} alt="" />
                            </p>
                            <p className="ant-upload-text">
                              <u>Click here</u> or drag & drop to upload .PDF
                              file
                            </p>
                          </Dragger>
                        )}
                      </Field>
                    ) : (
                      <div className="ant-upload-list ant-upload-list-text">
                        <span className="ant-upload-list-item-container">
                          <div className="d-flex gap-2 align-items-center file-icon">
                            <img src={uploadimg} alt="" />
                            {fileUploaded || spanishFileUpload}
                          </div>
                          <div className="d-flex gap-2 align-items-center">
                            <a href={fileUploadData?.signedUrl} target="_blank">
                              <img src={eye} alt="" />
                            </a>
                            <div
                              className="cursorPointer"
                              onClick={() => deleteFile()}
                            >
                              <img src={deleteicon} alt="" />
                            </div>
                          </div>
                        </span>
                      </div>
                    )}
                    <div className="text-end">
                      <button
                        className="sbg border-0 py3 fw-18 gbo continuebtn disclaimerBtn savebtn"
                        type="submit"
                      >
                        Save
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDpcDiscount;
